import {  Routes, Route } from 'react-router-dom';
import { Toaster } from "react-hot-toast";

import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import TemplateDetail from './pages/TemplateDetail';
import Footer from './components/Footer'
import Faqs from './pages/Faqs';
import Templates from './pages/Templates';
import PrivacyPolicyPage from './pages/Privacy';
import TermsPage from './pages/Terms';
import  {useScrollToTopOnNavigate} from './hooks/UseNavigateTop';
import LicensesPage from './pages/License';
import FeedbackPage from './pages/FeedBack';
import DocumentationPage from './pages/Docs/Document';
import SupportForm from './pages/SupportForm';
import NotFoundPage from './components/NotFound';
import Docs from './pages/Docs/Docs';
import ServicesPage from './pages/Services';
import BackToTop from './components/BackToTop';
import HomePage from './components/Enterprise'
import TemplateRequestsPage from './pages/TemplateRequest';
import PricingPage from './pages/Pricing';
import PartnersPage from './pages/Partners';
import {BlogList} from './pages/BlogList';
import {BlogPost} from './pages/BlogPost';
import SignupForm from './pages/Register';
import LoginForm from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import ProtectedRoute from "./hooks/ProtectedRoute";
import ServicesPageTemp from './pages/templateServices';
import PricingSuggestions from './pages/PricingSuggestionsPage';
import {AssetList} from './pages/Digital/AssetList';
import {AssetDetail} from './pages/Digital/AssetDetails';
import CartPage from './pages/Digital/Cart';
import { SiteMap } from './pages/SiteMap';
import {DataDeletionPage} from './pages/AccountDeletion'
import AdListComponent from './pages/lise'
import {DashboardWallet} from './Wallet-Dashboard/pages/Dashboard'
import AdDetail from './Wallet-Dashboard/pages/Ads/AdDetails';
import DigitalAssetDetail from "./Wallet-Dashboard/pages/Digitals/DigitalDetails";
import TemplateDetailPage from "./Wallet-Dashboard/pages/Digitals/TemplateDetails";

export default function App() {
  useScrollToTopOnNavigate();

  return (
    <div className="min-h-screen overflow-x-hidden bg-gray-50">
      <Navbar />
      <Toaster position="bottom-right" />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sitemap" element={<SiteMap />} />
          <Route path="/request-account-deletion" element={<DataDeletionPage />} />
          <Route path="/lisere" element={<AdListComponent />} />
          <Route path="/dashboard" element={<DashboardWallet />} />
          <Route path="/ads/:adId" element={<AdDetail />} />
          <Route path="/assets/details/:id" element={<DigitalAssetDetail />} />
          <Route path="/templates/details/:id" element={<TemplateDetailPage />} />








          <Route element={<ProtectedRoute />}>
          <Route path="/about" element={<About />} />
        </Route>
        <Route path="/assets" element={<AssetList />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/asset/:id" element={<AssetDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/template/:templateId" element={<TemplateDetail />} />
          <Route path="/faq" element={<Faqs />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/licenses" element={<LicensesPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />

          <Route
            path="/templates/installations/documentation"
            element={<Docs />}
          />
          <Route path="/templates/support/contact" element={<SupportForm />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route
            path="/templates/installations/docs"
            element={<DocumentationPage />}
          />
          <Route path="/pricing-suggestions" element={<PricingSuggestions />} />

          <Route path="/additionals/services" element={<ServicesPage />} />
          <Route path="/enterprise" element={<HomePage />} />
          <Route path="/template-request" element={<TemplateRequestsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="templates/blog" element={<BlogList />} />
          <Route path="/post/:id" element={<BlogPost />} />
          <Route path="/onboarding/register" element={<SignupForm />} />
          <Route path="/onboarding/login" element={<LoginForm />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/services" element={<ServicesPageTemp />}

          
          

          
          

          />
        </Routes>
      </main>
      <BackToTop />

      <Footer />
    </div>
  );
}